import request from '@/utils/request'

let ShareholderApi = {
  
    index(data) {
        return request._post('/shop/plus.shareholder.Shareholder/index', data);
    },
    /*设置*/
    setting(data) {
        return request._post('/shop/plus.shareholder.Shareholder/setting', data);
    },
    getSetting(data) {
        return request._get('/shop/plus.shareholder.Shareholder/getSetting', data);
    },
    // 添加循环返利
    addShareholder(data) {
        return request._get('/shop/plus.shareholder.Shareholder/addShareholder', data);
    },
     // 修改循环返利
    updShareholder(data) {
        return request._get('/shop/plus.shareholder.Shareholder/updShareholder', data);
    },
     // 删除循环返利
     deleteShareholder(data) {
        return request._get('/shop/plus.shareholder.Shareholder/deleteShareholder', data);
    },
    record(data) {
        return request._get('/shop/plus.shareholder.Shareholder/record', data);
    },
}
export default ShareholderApi;



// WEBPACK FOOTER //
// ./src/api/shareholder.js